/* BIA V3 — header sentinel + inner-media parallax. Supersedes bia.js behaviour. */
(function () {
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Header: solid by default; transparent ONLY while the hero sentinel
     is still below the header. Never white-on-white during load. */
  function header() {
    var h = document.querySelector('.hdr');
    if (!h || h.dataset.biaHdr === '1') return;
    h.dataset.biaHdr = '1';
    var sentinel = document.querySelector('.bia-sentinel');
    if (!sentinel) { h.classList.remove('is-over'); return; }
    if (!('IntersectionObserver' in window)) { h.classList.remove('is-over'); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { h.classList.toggle('is-over', e.isIntersecting || e.boundingClientRect.top > 0); });
    }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
    io.observe(sentinel);
    h.classList.add('is-over');
  }

  /* Parallax on the inner media only — the grid item never moves. */
  function parallax() {
    if (RM.matches || window.innerWidth < 901) return;
    var media = qa('[data-parallax] img');
    if (!media.length) return;
    var tick = false;
    function run() {
      tick = false;
      var vh = window.innerHeight;
      media.forEach(function (img) {
        var w = img.parentNode;
        var r = w.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        var y = Math.max(-14, Math.min(14, p * -14));
        img.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(1.06)';
      });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    window.addEventListener('resize', run, { passive: true });
    run();
  }

  function footerSeal() {
    var f = document.querySelector('.ft');
    if (!f || f.dataset.biaSeal === '1') return;
    f.dataset.biaSeal = '1';
    if (RM.matches || !('IntersectionObserver' in window)) { f.classList.add('in'); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { f.classList.add('in'); io.unobserve(f); } });
    }, { threshold: .15 });
    io.observe(f);
  }

  function boot() { header(); parallax(); footerSeal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
